"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var modal_1 = __importDefault(require("../../../../../plugins/modal"));
var app_1 = require("../../../../bundler/app");
var api_1 = require("../../../api");
var BundleComponents = __importStar(require("../../../bundle-components"));
var bundle_datepicker_1 = __importDefault(require("../../../components/bundle-datepicker"));
var callout_1 = require("../../../components/callout");
var loading_modal_1 = __importDefault(require("../../../components/loading-modal"));
var save_button_1 = require("../../../components/save_button");
var ActivateWipesLessBundleMutation = __importStar(require("../../../mutations/activate-wipesless-bundles"));
var ApplyDiscountSavetoSubscriptionMutation = __importStar(require("../../../mutations/apply-discount-save-to-subscription"));
var CancelSubscriptionMutation = __importStar(require("../../../mutations/cancel-subscription"));
var UpdateNextChargeDateMutation = __importStar(require("../../../mutations/update-next-charge-date"));
var UpdateSubscription = __importStar(require("../../../mutations/update-subscription"));
var record_snack_time_event_1 = require("../../../record-snack-time-event");
var add_bundles_1 = require("../../add-bundles");
/**
 * These aren't the only possible Brightback decisions, but they're the only ones handled by this component.
 */
var BrightbackDecision;
(function (BrightbackDecision) {
    BrightbackDecision["ACCEPTED_OFFER"] = "ao";
    BrightbackDecision["NEVERMIND"] = "n";
})(BrightbackDecision || (BrightbackDecision = {}));
var BrightbackOffer;
(function (BrightbackOffer) {
    BrightbackOffer["SWITCH_TO_FUNDAMENTALS"] = "stf";
    BrightbackOffer["MODIFY_BUNDLE"] = "mb";
    BrightbackOffer["MODIFY_FREQUENCY"] = "mf";
    BrightbackOffer["MODIFY_SHIP_DATE"] = "msd";
    BrightbackOffer["SKIP_SHIPMENT"] = "ss";
    BrightbackOffer["APPLY_DISCOUNT"] = "ad";
    BrightbackOffer["CHANGE_TO_WIPESLESS"] = "ctw";
})(BrightbackOffer || (BrightbackOffer = {}));
/**
 * Query string parameters that this component "owns"
 */
var BrightbackDecisionParam;
(function (BrightbackDecisionParam) {
    /** The decision that the user made in Brightback. */
    BrightbackDecisionParam["BRIGHTBACK_DECISION"] = "bbd";
    /** The offer that was accepted, if brightback_decision is ACCEPTED_OFFER. */
    BrightbackDecisionParam["ACCEPTED_OFFER"] = "ao";
    /** The step of the bundler that the customer will be sent directly to. */
    BrightbackDecisionParam["BUNDLER_STEP"] = "bs";
    /** The bundle type on the bundler that will be pre-selected. */
    BrightbackDecisionParam["BUNDLE_TYPE"] = "bt";
    /** The reason that the customer wanted to cancel their subscription. */
    BrightbackDecisionParam["REASON"] = "reason";
    /** New subscription frequency in weeks. */
    BrightbackDecisionParam["FREQUENCY"] = "frq";
    BrightbackDecisionParam["DISCOUNT_AMOUNT"] = "da";
    BrightbackDecisionParam["DISCOUNT_TYPE"] = "dt";
})(BrightbackDecisionParam || (BrightbackDecisionParam = {}));
/**
 * A mostly-business-logic component that handles the Brightback decision specified by the query parameters if the query parameters indicate that the customer
 * was redirected to this page from the Brightback experience with an ACCEPTED_OFFER or NEVERMIND decision.
 *
 * The easiest way to test the offers is to look at this Guru card and directly navigate to a URL that you write manually rather than trying to get Brightback to
 * show you the offer you're after: https://app.getguru.com/card/cAq9Grji/Brightback-Cancellation-Flow.
 * Your URL should look like: https://192.168.0.12:3000/account#/subscriptions/edit-items/307633259?bbd=ao&ao=ad&da=t&dt=f
 * More examples:
 * - https://192.168.0.12:3000/account#/subscriptions/edit-items/307633259?bbd=ao&ao=mf&frq=6
 * - https://192.168.0.12:3000/account#/subscriptions/edit-items/307633259?bbd=ao&ao=ss
 * - https://192.168.0.12:3000/account#/subscriptions/edit-items/307633259?bbd=ao&ao=ctw
 * Note that we're using the IP address version of the URL because if Brightback detects "localhost" anywhere in the request that's made to it, it'll respond with
 * a 403 Forbidden error for some reason. Note that this also applies to cookies from the Hello Bello site, so you may have to clear out all of your cookies after
 * starting to use your IP Address instead of localhost. You'll also need to clear out the customer-saves.received-discount-code shopify metafield on your shopify
 * customer record between each test discount application.
 */
var HandleBrightbackDecision = function (props) {
    var location = (0, react_router_dom_1.useLocation)();
    var _a = __read((0, react_1.useState)(), 2), nextShipDateChooserProps = _a[0], setNextShipDateChooserProps = _a[1];
    var _b = __read((0, react_1.useState)(), 2), noFurtherInteractionSuccessModalProps = _b[0], setNoFurtherInteractionSuccessModalProps = _b[1];
    var callout = (0, callout_1.useCallout)().callout;
    var _c = __read((0, react_1.useState)(''), 2), errorText = _c[0], setErrorText = _c[1];
    var _d = __read((0, react_1.useState)(true), 2), isProcessing = _d[0], setIsProcessing = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), nextChargeDateSaveButtonIsLoading = _e[0], setNextChargeDateSaveButtonIsLoading = _e[1];
    var cancelSubscriptionMutation = (0, react_query_1.useMutation)(function (variables) {
        return (0, api_1.getSubscriptionAPIClient)().request(CancelSubscriptionMutation.CANCEL_SUBSCRIPTION, variables);
    });
    var updateSubscriptionMutation = (0, react_query_1.useMutation)(function (variables) {
        return (0, api_1.getSubscriptionAPIClient)().request(UpdateSubscription.UPDATE_SUBSCRIPTION, variables);
    });
    var updateNextChargeDateMutation = (0, react_query_1.useMutation)(function (variables) {
        return (0, api_1.getSubscriptionAPIClient)().request(UpdateNextChargeDateMutation.UPDATE_NEXT_CHARGE_DATE, variables);
    });
    var applyDiscountSaveToSubscriptionMutation = (0, react_query_1.useMutation)(function (variables) {
        return (0, api_1.getSubscriptionAPIClient)().request(ApplyDiscountSavetoSubscriptionMutation.APPLY_DISCOUNT_SAVE_TO_SUBSCRIPTION, variables);
    });
    var activateWipeslessBundleMutation = (0, react_query_1.useMutation)(function (variables) {
        return (0, api_1.getSubscriptionAPIClient)().request(ActivateWipesLessBundleMutation.ACTIVATE_WIPESLESS_BUNDLES, variables);
    });
    var queryClient = (0, react_query_1.useQueryClient)();
    var history = (0, react_router_dom_1.useHistory)();
    (0, react_1.useEffect)(function () {
        var checkAndHandleBrightbackDecision = function () { return __awaiter(void 0, void 0, void 0, function () {
            var queryParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(props.groupedSubscription && isProcessing)) return [3 /*break*/, 2];
                        queryParams = query_string_1.default.parse(location.search);
                        if (!isBrightbackDecisionParams(queryParams)) return [3 /*break*/, 2];
                        return [4 /*yield*/, handleBrightbackDecision(queryParams, parseInt(props.subId, 10))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // This is redundant whenever the handler function sets isProcessing to false on its own, which occurs when it changes the state of the getSubscriptions
                        // react-query query. In either case, we display the loading modal until isProcessing is false to encourage the user to wait until we're done processing
                        // their Brightback decision. This should give us time to handle the Brightback decision, but we can't prevent the user from clicking away early.
                        setIsProcessing(false);
                        return [2 /*return*/];
                }
            });
        }); };
        checkAndHandleBrightbackDecision().catch(function (error) {
            console.error(error);
            setErrorText('Failed to process your subscription change. Please try again in a bit or contact Customer Service at 1-888-860-6888 if the problem persists.');
            cleanupProcessing();
        });
        return function () {
            cleanupProcessing();
        };
    }, [props.groupedSubscription]);
    /**
     * Handle query parameters that indicate a customer has made a decision within Brightback about whether or not to cancel a subscription.
     */
    var handleBrightbackDecision = function (params, subscriptionId) {
        if (params[BrightbackDecisionParam.BRIGHTBACK_DECISION] === BrightbackDecision.ACCEPTED_OFFER) {
            var contactCustomerServiceDirective = 'Please contact Customer Service at 1-888-860-6888.';
            if (params[BrightbackDecisionParam.ACCEPTED_OFFER] === BrightbackOffer.SWITCH_TO_FUNDAMENTALS) {
                return handleBrightbackSwitchToFundamentals(subscriptionId, params[BrightbackDecisionParam.REASON]);
            }
            else if (params[BrightbackDecisionParam.ACCEPTED_OFFER] === BrightbackOffer.MODIFY_BUNDLE) {
                return handleBrightbackModifyBundle(subscriptionId, params[BrightbackDecisionParam.BUNDLER_STEP], params[BrightbackDecisionParam.BUNDLE_TYPE], params[BrightbackDecisionParam.REASON], contactCustomerServiceDirective);
            }
            else if (params[BrightbackDecisionParam.ACCEPTED_OFFER] === BrightbackOffer.MODIFY_FREQUENCY) {
                return handleBrightbackModifyFrequency(subscriptionId, params[BrightbackDecisionParam.FREQUENCY], params[BrightbackDecisionParam.REASON], contactCustomerServiceDirective);
            }
            else if (params[BrightbackDecisionParam.ACCEPTED_OFFER] === BrightbackOffer.MODIFY_SHIP_DATE) {
                handleBrightbackModifyShipDate(subscriptionId, params[BrightbackDecisionParam.REASON], contactCustomerServiceDirective);
            }
            else if (params[BrightbackDecisionParam.ACCEPTED_OFFER] === BrightbackOffer.SKIP_SHIPMENT) {
                return handleBrightbackSkipShipment(subscriptionId, params[BrightbackDecisionParam.REASON], contactCustomerServiceDirective);
            }
            else if (params[BrightbackDecisionParam.ACCEPTED_OFFER] === BrightbackOffer.APPLY_DISCOUNT) {
                return handleBrightbackApplyDiscount(subscriptionId, params[BrightbackDecisionParam.DISCOUNT_AMOUNT], params[BrightbackDecisionParam.DISCOUNT_TYPE], params[BrightbackDecisionParam.REASON], contactCustomerServiceDirective);
            }
            else if (params[BrightbackDecisionParam.ACCEPTED_OFFER] === BrightbackOffer.CHANGE_TO_WIPESLESS) {
                return handleBrightbackChangeToWipesless(subscriptionId, params[BrightbackDecisionParam.REASON]);
            }
        }
        if (params[BrightbackDecisionParam.BRIGHTBACK_DECISION] === BrightbackDecision.NEVERMIND) {
            return (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                decisionIsFromBrightback: true,
                deflectionType: record_snack_time_event_1.DeflectionType.NEVERMIND,
                reason: params[BrightbackDecisionParam.REASON],
            });
        }
    };
    var handleBrightbackSwitchToFundamentals = function (subscriptionId, reason) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // this should never happen, but....
                    if (!((_a = props.groupedSubscription) === null || _a === void 0 ? void 0 : _a.address)) {
                        setErrorText('There was an error finding your address. Please contact support.');
                        cleanupProcessing();
                        return [2 /*return*/];
                    }
                    callout.success('Cancelling your bundle...');
                    return [4 /*yield*/, cancelSubscriptionMutation.mutateAsync({
                            comments: '(System: moving to new fundamentals bundle on return from Brightback)',
                            reason: reason || '',
                            subscriptionId: subscriptionId,
                        })];
                case 1:
                    _b.sent();
                    callout.success('Taking you to your new bundle...');
                    window.location.href = (0, add_bundles_1.createNewBundleExistingCustomerUrl)({
                        bundleType: 'Fundamentals',
                        addressId: props.groupedSubscription.address.id,
                    });
                    return [4 /*yield*/, (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                            decisionIsFromBrightback: true,
                            deflectionType: record_snack_time_event_1.DeflectionType.ACCEPTED_OFFER,
                            save: 'Changed to Fundamentals bundle',
                            reason: reason,
                        })];
                case 2:
                    _b.sent();
                    callout.success('Switched to the Fundamentals bundle!');
                    cleanupProcessing();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBrightbackModifyBundle = function (subscriptionId, bundlerStep, bundleType, reason, contactCustomerServiceDirective) {
        if (!isBundlerStep(bundlerStep)) {
            setErrorText("Unable to modify bundle. ".concat(contactCustomerServiceDirective));
            cleanupProcessing();
            return;
        }
        props.setBundlerPreSelections({
            directStep: bundlerStep,
            bundleType: translateShortBundleType(bundleType),
        });
        // We don't record a snacktime deflection action here because the user could still close the modal rather than following through and accepting the offer
        // and we want to specify which one happened in our deflection action. Instead we register some functions for when each of those things happen.
        props.setHandleEditBundleModalClosed(function () {
            // nested function nonsense so that the function is not invoked immediately: https://reactjs.org/docs/hooks-reference.html#functional-updates
            return function () {
                return (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                    decisionIsFromBrightback: true,
                    deflectionType: record_snack_time_event_1.DeflectionType.NEVERMIND,
                    reason: reason,
                });
            };
        });
        props.setHandleSubscriptionUpdated(function () {
            // nested function nonsense so that the function is not invoked immediately: https://reactjs.org/docs/hooks-reference.html#functional-updates
            return function () {
                return (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                    decisionIsFromBrightback: true,
                    deflectionType: record_snack_time_event_1.DeflectionType.ACCEPTED_OFFER,
                    save: 'Changed bundle type',
                    reason: reason,
                });
            };
        });
    };
    var handleBrightbackModifyFrequency = function (subscriptionId, newFrequency, reason, contactCustomerServiceDirective) { return __awaiter(void 0, void 0, void 0, function () {
        var frequency;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    frequency = parseInt(newFrequency, 10);
                    if (isNaN(frequency)) {
                        setErrorText("Unable to adjust your subscription's frequency. ".concat(contactCustomerServiceDirective));
                        cleanupProcessing();
                        return [2 /*return*/];
                    }
                    // TODO: consider parallelizing requests by not awaiting between each
                    return [4 /*yield*/, updateSubscriptionMutation.mutateAsync({
                            subscriptionId: subscriptionId,
                            updates: {
                                charge_interval_frequency: "".concat(newFrequency),
                                order_interval_frequency: "".concat(newFrequency),
                                // TODO: is the API okay with updating a subscription's order interval unit?
                                // Brightback always passes back the new frequency with a unit of weeks
                                order_interval_unit: 'week',
                            },
                        })
                        // record save in snacktime
                    ];
                case 1:
                    // TODO: consider parallelizing requests by not awaiting between each
                    _a.sent();
                    // record save in snacktime
                    return [4 /*yield*/, (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                            decisionIsFromBrightback: true,
                            deflectionType: record_snack_time_event_1.DeflectionType.ACCEPTED_OFFER,
                            save: "Changed frequency to ".concat(frequency),
                            reason: reason,
                        })
                        // show the user a success modal indicating that their change was applied
                    ];
                case 2:
                    // record save in snacktime
                    _a.sent();
                    // show the user a success modal indicating that their change was applied
                    setNoFurtherInteractionSuccessModalProps({
                        handleClose: handleExitNoFurtherInteractionSuccessModal,
                        image: window.accountApp.settings.brightbackImmediateSuccessModalImage,
                        message: "We changed your frequency to ".concat(frequency, " weeks!"),
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    /** First step in two-step process to modify ship date: spawn a modal to allow the customer to choose their new ship date */
    var handleBrightbackModifyShipDate = function (subscriptionId, reason, contactCustomerServiceDirective) {
        var _a;
        var startDate = (0, date_fns_1.parse)((_a = props.groupedSubscription) === null || _a === void 0 ? void 0 : _a.subscription.next_charge_scheduled_at, "yyyy-MM-dd'T'HH:mm:ss", new Date());
        if (!(0, date_fns_1.isValid)(startDate)) {
            setErrorText("Unable to update ship date. ".concat(contactCustomerServiceDirective));
            cleanupProcessing();
            return;
        }
        setNextShipDateChooserProps({
            startDate: startDate,
            subscriptionId: subscriptionId,
            onEditNextChargeDateSubmit: onEditNextChargeDateSubmit,
            saveButtonIsLoading: nextChargeDateSaveButtonIsLoading,
            reason: reason,
        });
    };
    /** Second step in two-step process to modify ship date: save the user's selection and record the deflection in Snacktime */
    var onEditNextChargeDateSubmit = function (subscriptionId, selectedDate, reason) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!subscriptionId)
                        return [2 /*return*/];
                    setNextChargeDateSaveButtonIsLoading(true);
                    return [4 /*yield*/, updateNextChargeDateMutation.mutateAsync({
                            nextChargeDate: selectedDate.toISOString(),
                            subscriptionId: subscriptionId,
                        })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                            decisionIsFromBrightback: true,
                            deflectionType: record_snack_time_event_1.DeflectionType.ACCEPTED_OFFER,
                            save: "Changed next charge date to ".concat((0, date_fns_1.format)(selectedDate, 'yyyy-MM-dd')),
                            reason: reason,
                        })];
                case 2:
                    _a.sent();
                    setNextChargeDateSaveButtonIsLoading(false);
                    callout.success("Changed your next ship date to ".concat((0, date_fns_1.format)(selectedDate, 'MM/dd/yyyy'), "!"));
                    cleanupProcessing();
                    setNextShipDateChooserProps(undefined);
                    return [2 /*return*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
            }
        });
    }); };
    /**
     * Alternate second step in two-step process to modify ship date (when user exits date picker instead of selecting a new next order date): record a
     * nevermind deflection in Snacktime
     */
    var handleExitNextChargeDatePicker = function (input) {
        setNextShipDateChooserProps(undefined);
        return (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, input.subscriptionId, {
            decisionIsFromBrightback: true,
            deflectionType: record_snack_time_event_1.DeflectionType.NEVERMIND,
            reason: input.reason,
        });
    };
    var handleExitNoFurtherInteractionSuccessModal = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setNoFurtherInteractionSuccessModalProps(undefined);
            cleanupProcessing();
            // once cleanupProcessing has removed the url parameters associated with Brightback, we can reload the page to refresh pricing information
            window.location.reload();
            return [2 /*return*/];
        });
    }); };
    var handleBrightbackSkipShipment = function (subscriptionId, reason, contactCustomerServiceDirective) { return __awaiter(void 0, void 0, void 0, function () {
        var nextChargeScheduledAt, orderFrequency, orderFrequencyUnit, currentNextChargeDate, newNextChargeDate, newNextChargeDateTimestamp;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    nextChargeScheduledAt = (_a = props.groupedSubscription) === null || _a === void 0 ? void 0 : _a.subscription.next_charge_scheduled_at;
                    orderFrequency = parseInt((_b = props.groupedSubscription) === null || _b === void 0 ? void 0 : _b.subscription.order_interval_frequency, 10);
                    orderFrequencyUnit = (_c = props.groupedSubscription) === null || _c === void 0 ? void 0 : _c.subscription.order_interval_unit;
                    if (!nextChargeScheduledAt || isNaN(orderFrequency) || !orderFrequencyUnit) {
                        setErrorText("Unable to skip a shipment. ".concat(contactCustomerServiceDirective));
                        cleanupProcessing();
                        return [2 /*return*/];
                    }
                    currentNextChargeDate = (0, date_fns_1.parse)(nextChargeScheduledAt, "yyyy-MM-dd'T'HH:mm:ss", new Date());
                    if (orderFrequencyUnit === 'day') {
                        newNextChargeDate = (0, date_fns_1.add)(currentNextChargeDate, { days: orderFrequency });
                    }
                    else if (orderFrequencyUnit === 'week') {
                        newNextChargeDate = (0, date_fns_1.add)(currentNextChargeDate, { weeks: orderFrequency });
                    }
                    else if (orderFrequencyUnit === 'month') {
                        newNextChargeDate = (0, date_fns_1.add)(currentNextChargeDate, { months: orderFrequency });
                    }
                    if (!newNextChargeDate) {
                        setErrorText("Unable to skip a shipment. ".concat(contactCustomerServiceDirective));
                        cleanupProcessing();
                        return [2 /*return*/];
                    }
                    newNextChargeDateTimestamp = (0, date_fns_1.format)(newNextChargeDate, 'yyyy-MM-dd');
                    return [4 /*yield*/, updateNextChargeDateMutation.mutateAsync({ nextChargeDate: newNextChargeDateTimestamp, subscriptionId: subscriptionId })];
                case 1:
                    _d.sent();
                    return [4 /*yield*/, (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                            decisionIsFromBrightback: true,
                            deflectionType: record_snack_time_event_1.DeflectionType.ACCEPTED_OFFER,
                            save: "Skipped shipment. Changed next charge date from ".concat((0, date_fns_1.format)(currentNextChargeDate, 'yyyy-MM-dd'), " to ").concat(newNextChargeDateTimestamp),
                            reason: reason,
                        })];
                case 2:
                    _d.sent();
                    setNoFurtherInteractionSuccessModalProps({
                        handleClose: handleExitNoFurtherInteractionSuccessModal,
                        image: window.accountApp.settings.brightbackImmediateSuccessModalImage,
                        message: "We've moved your order to ".concat((0, date_fns_1.format)(newNextChargeDate, 'MM/dd/yyyy'), "!"),
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBrightbackApplyDiscount = function (subscriptionId, disAmount, disType, reason, contactCustomerServiceDirective) { return __awaiter(void 0, void 0, void 0, function () {
        var discountAmount, discountType, bundleComponents, result, discountAppliedSuccessfully, save, discountAmountDisplay;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    discountAmount = translateDiscountAmountQueryParam(disAmount);
                    discountType = translateDiscountTypeQueryParam(disType);
                    if (!discountType || discountAmount === undefined || !props.groupedSubscription) {
                        setErrorText("Unable to apply discount. ".concat(contactCustomerServiceDirective));
                        cleanupProcessing();
                        return [2 /*return*/];
                    }
                    bundleComponents = new BundleComponents.default(props.groupedSubscription);
                    return [4 /*yield*/, applyDiscountSaveToSubscriptionMutation.mutateAsync({
                            subscriptionId: subscriptionId,
                            bundleType: translateBundleComponentsBundleTypeToSubApiApplyDiscountSaveToSubscriptionBundleType(bundleComponents.getBundleType()),
                            offerSource: 'brightback',
                            offerType: discountType,
                            offerAmount: discountAmount,
                        })];
                case 1:
                    result = _a.sent();
                    discountAppliedSuccessfully = result.applyDiscountSaveToSubscription;
                    if (!discountAppliedSuccessfully) {
                        setErrorText("Your discount could not be applied. ".concat(contactCustomerServiceDirective));
                        cleanupProcessing();
                        return [2 /*return*/];
                    }
                    save = discountType === ApplyDiscountSavetoSubscriptionMutation.OfferType.FIXED_AMOUNT
                        ? "Applied ".concat(discountAmount, " dollar discount")
                        : "Applied ".concat(discountAmount, " percentage discount");
                    return [4 /*yield*/, (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                            decisionIsFromBrightback: true,
                            deflectionType: record_snack_time_event_1.DeflectionType.ACCEPTED_OFFER,
                            save: save,
                            reason: reason,
                        })];
                case 2:
                    _a.sent();
                    discountAmountDisplay = discountType === ApplyDiscountSavetoSubscriptionMutation.OfferType.FIXED_AMOUNT ? "$".concat(discountAmount) : "".concat(discountAmount, "%");
                    setNoFurtherInteractionSuccessModalProps({
                        handleClose: handleExitNoFurtherInteractionSuccessModal,
                        image: window.accountApp.settings.brightbackImmediateSuccessModalImage,
                        message: "You've applied ".concat(discountAmountDisplay, " off your next Bundle!"),
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBrightbackChangeToWipesless = function (subscriptionId, reason) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, activateWipeslessBundleMutation.mutateAsync({ subscriptionId: subscriptionId })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, subscriptionId, {
                            decisionIsFromBrightback: true,
                            deflectionType: record_snack_time_event_1.DeflectionType.ACCEPTED_OFFER,
                            save: 'Changed to wipesless bundle',
                            reason: reason,
                        })];
                case 2:
                    _a.sent();
                    setNoFurtherInteractionSuccessModalProps({
                        handleClose: handleExitNoFurtherInteractionSuccessModal,
                        image: window.accountApp.settings.brightbackImmediateSuccessModalImage,
                        message: "We've removed wipes from your Bundle!",
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var cleanupProcessing = function () {
        var e_1, _a;
        var queryParams = query_string_1.default.parse(location.search);
        try {
            // delete all query string params that this component "owns"
            for (var _b = __values(Object.values(BrightbackDecisionParam)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var queryParam = _c.value;
                delete queryParams[queryParam];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        history.replace({
            search: query_string_1.default.stringify(queryParams),
        });
        setIsProcessing(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(loading_modal_1.default, { isLoading: isProcessing, error: errorText, errorMessage: errorText }),
        react_1.default.createElement(modal_1.default, { isOpen: !!nextShipDateChooserProps, handleClose: function () { return handleExitNextChargeDatePicker(nextShipDateChooserProps); } },
            react_1.default.createElement("div", { className: 'padding-top-10 padding-bottom-10 padding-right-10 padding-left-10' },
                react_1.default.createElement(NextShipDateChooser, __assign({}, nextShipDateChooserProps, { saveButtonIsLoading: nextChargeDateSaveButtonIsLoading })))),
        noFurtherInteractionSuccessModalProps && (react_1.default.createElement(modal_1.default, { isOpen: !!noFurtherInteractionSuccessModalProps, handleClose: noFurtherInteractionSuccessModalProps.handleClose },
            react_1.default.createElement("div", { className: 'width-100 padding-6', style: { maxWidth: 500 } },
                react_1.default.createElement(NoFurtherInteractionSuccess, __assign({}, noFurtherInteractionSuccessModalProps)))))));
};
var isBrightbackDecisionParams = function (value) {
    var typedValue = value;
    return Object.values(BrightbackDecision).includes(typedValue[BrightbackDecisionParam.BRIGHTBACK_DECISION]);
};
var isBundlerStep = function (bundlerStep) {
    return Object.values(app_1.BundlerStep).includes(bundlerStep);
};
var translateShortBundleType = function (shortBundleType) {
    switch (shortBundleType) {
        case 'd':
            return 'Diapers';
        case 'tp':
            return 'TrainingPants';
        case 'm':
            return 'Mixed';
    }
};
var translateDiscountAmountQueryParam = function (discountAmount) {
    // security by obscurity
    switch (discountAmount) {
        case 'f':
            return 5;
        case 't':
            return 10;
        case 'ft':
            return 15;
        case 'tw':
            return 20;
        case 'tf':
            return 25;
    }
};
var translateDiscountTypeQueryParam = function (discountType) {
    switch (discountType) {
        case 'f':
            return ApplyDiscountSavetoSubscriptionMutation.OfferType.FIXED_AMOUNT;
        case 'p':
            return ApplyDiscountSavetoSubscriptionMutation.OfferType.PERCENTAGE;
    }
};
var NextShipDateChooser = function (props) {
    var _a = __read((0, react_1.useState)(props.startDate), 2), selectedDate = _a[0], setSelectedNextDate = _a[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'text-center' },
            react_1.default.createElement("h3", null, "Need a Break?"),
            react_1.default.createElement("div", { className: 'divider bg-cornflower-blue margin-vertical-4 margin-horizontal-auto' }),
            react_1.default.createElement("div", null, "No problem! Choose when you want your next bundle below.")),
        react_1.default.createElement("div", { className: 'text-center margin-vertical-6' },
            react_1.default.createElement(bundle_datepicker_1.default, { onChange: function (newDate) { return (newDate ? setSelectedNextDate(newDate) : null); }, selected: selectedDate, startDate: props.startDate, maxDate: (0, date_fns_1.add)(new Date(), { months: 3 }), inline: true })),
        react_1.default.createElement("div", { className: 'grid-x grid-margin-x align-middle align-justify' },
            react_1.default.createElement(save_button_1.SaveButton, { onClick: function () { return props.onEditNextChargeDateSubmit(props.subscriptionId, selectedDate, props.reason); }, isLoading: props.saveButtonIsLoading, extraClassNames: ['blocky-button', 'filled', 'animate-loading-spinner'] }))));
};
/**
 * For indicating to the user that the decision they made in brightback has been automatically
 * applied and that no further interaction is necessary to redeem their reward.
 */
var NoFurtherInteractionSuccess = function (_a) {
    var message = _a.message, image = _a.image, handleClose = _a.handleClose;
    return (react_1.default.createElement("div", { className: 'flex-container flex-dir-column align-middle', style: { gap: 10 } },
        react_1.default.createElement("div", { className: 'text-center text-xl' }, "Woohoo!"),
        image && react_1.default.createElement("img", { className: 'object-fit-contain', style: { height: 250 }, src: image.src, alt: image.alt }),
        react_1.default.createElement("div", { className: 'padding-horizontal-4 text-center text-lg' }, message),
        react_1.default.createElement("button", { onClick: handleClose, className: 'cell medium-6 button text-lg wisteria padding-vertical-5' }, "See My Account")));
};
/**
 * @todo Create a single BundleType enum or type to use across this repo and between this repo and subscriptions-api
 */
var translateBundleComponentsBundleTypeToSubApiApplyDiscountSaveToSubscriptionBundleType = function (bundleType) {
    switch (bundleType) {
        case 'Diaper':
            return 'Diaper';
        case 'Fundamentals':
            return 'Fundamentals';
        case 'Training Pant':
            return 'TrainingPant';
        case 'Vitamin':
            return 'Vitamin';
    }
};
exports.default = HandleBrightbackDecision;
